import palette from "../palette";

export default {
    root: {
        backgroundColor: "#392d45",
    },
};
